import { render, staticRenderFns } from "./updateProfileSetting.vue?vue&type=template&id=0d6cd224&lang=pug"
import script from "./updateProfileSetting.vue?vue&type=script&lang=js"
export * from "./updateProfileSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports